import { useVersionCheck } from '@/hooks/versioning/useVersionCheck';

const VersionGuard = ({ children }: { children: React.ReactNode }) => {
  const { isVersionMismatch } = useVersionCheck();

  if (isVersionMismatch) {
    // Update the local storage with the new version before reloading is tricky
    // because we don't have the new hash here easily without refetching or passing it.
    // However, simply reloading the page will cause the hook to run again on mount.
    // To prevent an infinite loop of "mismatch -> reload -> mismatch (because storage still old)",
    // we should actually clear the storage or rely on the fact that the *new* page load
    // will have the *new* application code which might expect the *new* hash.

    // BUT, the logic in the hook is:
    // 1. Fetch JSON (Hash B)
    // 2. Read Storage (Hash A)
    // 3. A != B -> Mismatch.

    // If we reload, the JS code reloads. The hook runs again.
    // 1. Fetch JSON (Hash B)
    // 2. Read Storage (Hash A) (It's still A!)
    // 3. A != B -> Mismatch. -> LOOP!

    // So we MUST update the local storage before reloading.
    // Since we don't have the new hash in this component scope, a safe bet is to
    // CLEAR the local storage key. The hook handles "no storage" by setting it to current.

    localStorage.removeItem('app_version_hash');
    window.location.reload();
  }

  return <>{children}</>;
};

export default VersionGuard;
